import React, { useMemo } from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import { AddShipFromLink } from './add-ship-from-link';
import { ShipFromCard } from './ship-from-card';
import style from './style.module.less';
import { useShipFroms } from '../../../../../../../hooks/ship-froms/use-ship-froms';
import { useFilteredTodoCards } from '../../../../todo-cards/helpers/should-show-todo-card';
import { todoCardData } from '../../../../todo-cards/todo-card-data';
import { todoPageIds } from '../../../../todo-cards/todo-card-ids';
import { TodoCardsContainer } from '../../../../todo-cards/todo-cards-container';

/**
 * @param {object} props - Component props
 * @param {() => void} [props.onSuccess] - Callback function called when a new ship-from location is successfully added
 * @returns {React.ReactElement} A grid of ship-from location cards with an add button
 */
export const ShipFromLocationsCards = ({ onSuccess }) => {
  const shipFroms = useShipFroms();
  const todoCards = useFilteredTodoCards(todoCardData, {
    pageWhereRendered: todoPageIds.CONNECTED_SHIP_FROM_PAGE,
  });

  const sortedShipFroms = useMemo(() => {
    const defaultShipFrom = shipFroms.find((sf) => sf.isDefault);
    return [defaultShipFrom, ...shipFroms.filter((sf) => !sf.isDefault)];
  }, [shipFroms]);

  return (
    <FlexColumn className={style['ship-from-cards']}>
      <FlexColumn>
        <div className={style['ship-from-cards-grid']}>
          {sortedShipFroms.map((shipFrom) => (
            <ShipFromCard key={shipFrom.shipFromId} shipFrom={shipFrom} />
          ))}
        </div>
        <AddShipFromLink onSuccess={onSuccess} />
      </FlexColumn>
      <TodoCardsContainer todoCards={todoCards} />
    </FlexColumn>
  );
};
